import slugify from 'slugify'

import { httpClient } from '@/services/http/httpClient'

import type { IdeaFieldFormat } from '@/types/ideaFieldsFormat'

type Params = {
  title: string
  description?: string
  format: IdeaFieldFormat
  options: { name: string }[]
  isMandatory: boolean
}

export async function createIdeaFieldTemplate({
  title,
  description,
  format,
  options,
  isMandatory,
}: Params) {
  await httpClient.post('/ideas/campaigns/field-templates', {
    title,
    name: slugify(title, {
      lower: true,
      trim: true,
      replacement: '-',
    }),
    description,
    format,
    formatOptions: options,
    isMandatory,
  })
}
